<div id="container">
  <div class="patient-overview-frame">
    <!-- <app-window-title [closable]="false"
                      [title]="'Patient Overview'"></app-window-title> -->

    <!-- Loading state -->
    <div *ngIf="isLoading"
         class="fx-ai-center fx-col fx-jc-center loading-container">
      <mat-progress-spinner diameter="50"></mat-progress-spinner>
      <p style="margin-top: 20px">
        Loading patient data...
      </p>
    </div>

    <!-- Error state -->
    <div *ngIf="hasError && !isLoading"
         class="error-container fx-ai-center fx-col fx-jc-center">
      <mat-icon style="font-size: 48px; color: #c62828; margin-bottom: 16px">
        error
      </mat-icon>
      <p>
        {{ errorMessage }}
      </p>
      <button color="primary"
              style="margin-top: 16px"
              mat-button
              (click)="router.navigate(['/'])">
        Go Back to Home
      </button>
    </div>

    <!-- Main content -->
    <div *ngIf="!isLoading && !hasError && vm.patient"
         class="fx-ai-stretch fx-row main-section"
         [class.sharing-mode]="showSharingSetup && !vm.isImageShareMode"
         [class.split-mode]="vm.isImageShareMode">
      <div class="fx-flex-20 left-panel">
        <!-- Basic patient information — hidden when studies results span multiple patients -->
        <app-patient-basic-info *ngIf="!studiesHaveMultiplePatients"

                                [compact]="vm.isImageShareMode"
                                [existsInSystem]="!(studiesFoundPatient && studiesFoundPatientExists === false)"
                                [patient]="studiesFoundPatient || vm.patient"

                                (changePatient)="onChangePatient()"
                                (createPatient)="onCreatePatient()"
                                (editPatient)="onEditPatient()">
        </app-patient-basic-info>

        <!-- Target set: SOURCE→TARGET + Change / Clear buttons -->
        <ng-container *ngIf="activeImageShareTab === 'studies' && selectedTargetFacility && !showChangeTargetPicker">
          <app-facility-animation [action]="shareDirection === 'send' ? 'SEND' : (shareDirection === 'receive' ? 'RETRIEVE' : 'SEND')"
                                  [compact]="true"
                                  [origin]="currentFacilityName"
                                  [showChangeTarget]="!isSpokeUser"
                                  [target]="targetFacilityName"
                                  (changeTarget)="onOpenChangeTargetPicker()">
          </app-facility-animation>
        </ng-container>

        <!-- Facility picker — shared between "Set Default Target" (no target) and "Change Target" (has target) -->
        <div *ngIf="activeImageShareTab === 'studies' && showChangeTargetPicker"
             class="change-target-picker">
          <app-patients-actions-facility [facilities]="vm.facilities"
                                         [selectedFacility]="selectedTargetFacility"
                                         (facilitySelected)="onChangeTargetFacilitySelected($event)">
          </app-patients-actions-facility>
          <button class="change-target-cancel-btn"
                  mat-button
                  (click)="onCancelChangeTargetPicker()">
            <mat-icon>
              close
            </mat-icon>
            Cancel
          </button>
        </div>

        <!-- No target set: show "Set Default Target" button -->
        <ng-container *ngIf="activeImageShareTab === 'studies' && !selectedTargetFacility && !isSpokeUser">
          <div class="no-target-hint">
            <mat-icon class="no-target-icon">
              send
            </mat-icon>
            <span>
              No default target
            </span>
          </div>
          <button class="set-default-target-btn"
                  mat-button
                  matTooltip="Pin a facility — all sends go there directly without prompting"
                  (click)="onOpenChangeTargetPicker()">
            <mat-icon>
              push_pin
            </mat-icon>
            Set Default Target
          </button>
          <button *ngIf="patientSharesLoaded"
                  class="view-share-history-btn"
                  mat-button
                  (click)="openShareHistoryModal()">
            <mat-icon>
              history
            </mat-icon>
            View share history
          </button>
        </ng-container>



        <!-- Patient IDs remains full width -->
        <!-- <div class="info-field">
        <div class="field-value">
          <app-patient-ids class="patient-ids-full-width"
                           [currentFacility]="vm.currentFacility"
                           [patientIDs]="vm.patient?.patientIDs"
                           [resetToken]="vm.patientIdsResetToken"
                           (selectedPatientIdEvent)="onSelectedPatientIdEvent($event)"></app-patient-ids>
        </div>
      </div> -->

        <!-- Transfer Visualization in fullscreen mode -->
        <!-- <div *ngIf="vm.isImageShareMode && selectedTargetFacility"
             class="transfer-visualization-fullscreen">
          <app-transfer-visualization [destinationFacility]="destinationFacility"
                                      [exchangeMode]="exchangeMode"
                                      [facilitators]="facilitators"
                                      [sourceFacility]="sourceFacility">
          </app-transfer-visualization>
        </div> -->

        <app-send-instructions *ngIf="shouldShowSendInstructions"
                               [caseName]="vm.patient?.caseName"
                               [facilitators]="facilitators"
                               [patientId]="vm.patient?.patientId"
                               [senderFacility]="vm.currentFacility"
                               [targetFacility]="selectedTargetFacility?.facility">
        </app-send-instructions>

        <app-retrieve-instructions *ngIf="shouldShowRetrieveInstructions"
                                   [caseName]="vm.patient?.caseName"
                                   [facilitators]="facilitators"
                                   [patientId]="vm.patient?.patientId"
                                   [senderFacility]="vm.currentFacility"
                                   [targetFacility]="selectedTargetFacility?.facility">
        </app-retrieve-instructions>

        <!-- Navigation buttons -->
        <app-patient-overview-navigation (backToHome)="onBackToHome()"
                                         (backToPatientOverview)="onBackToPatientOverview()"
                                         (backToPatientsList)="onBackToPatientsList()">
        </app-patient-overview-navigation>
      </div>

      <!-- Sharing Setup - Right 50% when not in image share mode -->
      <div *ngIf="showSharingSetup && !vm.isImageShareMode"
           class="fx-flex-80 right-panel">
        <!-- Title Bar -->
        <div class="sharing-setup-title-bar">
          <div class="sharing-setup-title-content">
            <mat-icon class="sharing-setup-title-icon">
              swap_horiz
            </mat-icon>
            <span class="sharing-setup-title-text">
              <span *ngIf="!vm.shareTypeSelected && !shareDirection">
                Images and Documents Exchange
              </span>
              <span *ngIf="vm.shareTypeSelected || shareDirection">
                <span *ngIf="vm.shareTypeSelected === 'image'">
                  Images Exchange
                </span>
                <span *ngIf="vm.shareTypeSelected === 'document'">
                  Documents Exchange
                </span>
                <span *ngIf="!vm.shareTypeSelected">
                  Images and Documents Exchange
                </span>
                <span *ngIf="shareDirection === 'send'"
                      class="sharing-setup-direction">
                  - SEND
                </span>
                <span *ngIf="shareDirection === 'receive'"
                      class="sharing-setup-direction">
                  - RETRIEVE
                </span>
              </span>
              <span *ngIf="selectedTargetFacility?.facility"
                    class="sharing-setup-facility-name">
                - {{ getFormattedFacilityName(selectedTargetFacility.facility) }}
              </span>
            </span>
          </div>
        </div>

        <!-- Transfer Visualization - Centered and on top, just below title -->
        <!-- <div *ngIf="selectedTargetFacility && !vm.isImageShareMode"
             class="transfer-visualization-container">
          <app-transfer-visualization [destinationFacility]="destinationFacility"
                                      [exchangeMode]="exchangeMode"
                                      [facilitators]="facilitators"
                                      [sourceFacility]="sourceFacility"
                                      (editDestinationFacility)="onEditDestinationFacility()">
          </app-transfer-visualization>
        </div> -->


      </div>

      <div *ngIf="!vm.isImageShareMode && !showSharingSetup"
           class="patient-info-right">
        <!-- Narrow-link banner: Spoke linked their MRN but has no full share -->
        <div *ngIf="isNarrowLink"
             class="narrow-link-banner">
          <mat-icon class="narrow-link-icon">
            link
          </mat-icon>
          <div class="narrow-link-text">
            <strong>
              Linked — Send Only
            </strong>
            <span>
              Your facility has linked to this patient. You can send images but cannot access files or
              documents.
            </span>
          </div>
        </div>
        <!-- Decision Screen - Show in right side when decision screen is active -->
        <div *ngIf="showDecisionScreen && !activeDocumentComponent"
             class="decision-screen-container">
          <app-patients-actions [dateOfBirth]="vm.patient?.dob || vm.patient?.DateOfBirth || ''"
                                [facilities]="vm.facilities"
                                [gender]="vm.patient?.gender || ''"
                                [otherPatientIds]="vm.otherPatientIDs"
                                [pacsUrl]="facilityPacsUrl"
                                [patientId]="vm.patient?.caseName || vm.patient?.patientId || ''"
                                [patientName]="(vm.patient?.firstname || vm.patient?.FirstName || '') + ' ' + (vm.patient?.lastname || vm.patient?.LastName || '')"
                                [selectedTargetFacility]="selectedTargetFacility"
                                [sourceFacility]="currentFacilityName"
                                (continue)="onPatientsActionsContinue($event)"
                                (decisionSelected)="onPatientsActionsDecisionSelected($event)"
                                (devClientProfileRequested)="devOpenClientProfile()"
                                (facilitySelected)="onPatientsActionsFacilitySelected($event)"
                                (openClientProfile)="onPatientsActionsOpenClientProfile()"
                                (openPacsRequested)="onPatientsActionsOpenPacs()"
                                (resetRequested)="onPatientsActionsReset()">
          </app-patients-actions>

        </div>

        <!-- Document Components - Show in right zone when document option is selected -->
        <div *ngIf="activeDocumentComponent === 'share'"
             class="document-component-container">
          <app-patient-share-documents [patientFromParent]="vm.patient"
                                       [patientID]="vm.patient?.caseName"></app-patient-share-documents>
        </div>

        <div *ngIf="activeDocumentComponent === 'retrieve'"
             class="document-component-container">
          <app-patient-retrieve-documents [patientFromParent]="vm.patient"
                                          [patientID]="vm.patient?.caseName"></app-patient-retrieve-documents>
        </div>

        <!-- Patient Picture - Show when decision screen is not active and no document component -->
        <div *ngIf="!showDecisionScreen && !activeDocumentComponent"
             class="patient-picture-section">
          <div class="picture-placeholder">
            <img *ngIf="vm.patient?.patientPicture"
                 class="patient-image"
                 alt="Patient Picture"
                 [src]="vm.patient.patientPicture">
            <div *ngIf="!vm.patient?.patientPicture"
                 class="no-image">
              <mat-icon>
                person
              </mat-icon>
              <span>
                PATIENT PICTURE
              </span>
            </div>
          </div>
        </div>

        <!-- Auto-Forwarding — Hub users only, not shown for narrow-linked patients -->
        <app-auto-forwarding-section *ngIf="!isSpokeUser && !isNarrowLink && vm.patient?.caseName && vm.currentFacility"
                                     [caseName]="vm.patient.caseName"
                                     [hubFacilityId]="vm.currentFacility">
        </app-auto-forwarding-section>
      </div>

      <div *ngIf="vm.isImageShareMode"
           #imageShareRight
           class="image-share-right">
        <div *ngIf="activeImageShareTitle || shareDirection"
             class="image-share-header">
          <nav class="breadcrumb-nav">
            <!-- Type crumb -->
            <button class="breadcrumb-btn"
                    mat-button
                    [matMenuTriggerFor]="typeMenu">
              <span class="breadcrumb-content">
                <mat-icon class="breadcrumb-icon">
                  {{vm.shareTypeSelected === 'document' ? 'description' : 'collections'}}
                </mat-icon>
                <span>
                  {{vm.shareTypeSelected === 'document' ? 'Documents' : 'Images'}}
                </span>
                <mat-icon class="breadcrumb-drop-icon">
                  arrow_drop_down
                </mat-icon>
              </span>
            </button>
            <mat-menu #typeMenu="matMenu">
              <button *ngIf="vm.shareTypeSelected !== 'image'"
                      mat-menu-item
                      (click)="onBreadcrumbSwitchType('image')">
                <mat-icon>
                  collections
                </mat-icon>
                <span>
                  Images
                </span>
              </button>
              <button *ngIf="vm.shareTypeSelected !== 'document'"
                      mat-menu-item
                      (click)="onBreadcrumbSwitchType('document')">
                <mat-icon>
                  description
                </mat-icon>
                <span>
                  Documents
                </span>
              </button>
            </mat-menu>

            <!-- Separator -->
            <mat-icon class="breadcrumb-sep">
              chevron_right
            </mat-icon>

            <!-- Direction crumb (when direction is already set) -->
            <ng-container *ngIf="shareDirection">
              <!-- Spoke users: non-interactive label (they can only retrieve) -->
              <span *ngIf="isSpokeUser"
                    class="breadcrumb-btn breadcrumb-btn-receive breadcrumb-label">
                <mat-icon class="breadcrumb-icon">
                  arrow_downward
                </mat-icon>
                <span>
                  Retrieve
                </span>
              </span>
              <!-- Hub users: clickable dropdown to switch Send ↔ Retrieve -->
              <button *ngIf="!isSpokeUser"

                      class="breadcrumb-btn"
                      mat-button

                      [class.breadcrumb-btn-receive]="shareDirection === 'receive'"
                      [class.breadcrumb-btn-send]="shareDirection === 'send'"
                      [matMenuTriggerFor]="directionMenu">
                <span class="breadcrumb-content">
                  <mat-icon class="breadcrumb-icon">
                    {{shareDirection === 'send' ? 'arrow_upward' : 'arrow_downward'}}
                  </mat-icon>
                  <span>
                    {{shareDirection === 'send' ? 'Send' : 'Retrieve'}}
                  </span>
                  <mat-icon class="breadcrumb-drop-icon">
                    arrow_drop_down
                  </mat-icon>
                </span>
              </button>
              <mat-menu #directionMenu="matMenu">
                <button *ngIf="shareDirection !== 'send' && !isSpokeUser"
                        mat-menu-item
                        (click)="onBreadcrumbSwitchDirection('send')">
                  <mat-icon>
                    arrow_upward
                  </mat-icon>
                  <span>
                    Send
                  </span>
                </button>
                <button *ngIf="shareDirection !== 'receive'"
                        mat-menu-item
                        (click)="onBreadcrumbSwitchDirection('receive')">
                  <mat-icon>
                    arrow_downward
                  </mat-icon>
                  <span>
                    Retrieve
                  </span>
                </button>
              </mat-menu>
            </ng-container>

            <!-- Direction picker (shown when no direction, e.g. after switching to Documents) -->
            <ng-container *ngIf="!shareDirection">
              <button *ngIf="!isSpokeUser"
                      class="breadcrumb-btn breadcrumb-btn-send"
                      mat-button
                      (click)="onBreadcrumbSwitchDirection('send')">
                <span class="breadcrumb-content">
                  <mat-icon class="breadcrumb-icon">
                    arrow_upward
                  </mat-icon>
                  <span>
                    Send
                  </span>
                </span>
              </button>
              <span *ngIf="!isSpokeUser"
                    class="breadcrumb-or">
                or
              </span>
              <button class="breadcrumb-btn breadcrumb-btn-receive"
                      mat-button
                      (click)="onBreadcrumbSwitchDirection('receive')">
                <span class="breadcrumb-content">
                  <mat-icon class="breadcrumb-icon">
                    arrow_downward
                  </mat-icon>
                  <span>
                    Retrieve
                  </span>
                </span>
              </button>
            </ng-container>
          </nav>
        </div>
        <div *ngIf="activeImageShareTab === 'studies' && vm.shareTypeSelected !== 'document'"
             class="studies-container"
             style="height: calc(100% - 45px); display: flex; flex-direction: column; width: 100%; overflow: auto">
          <app-studies-page [exchangeAction]="shareDirection === 'send' ? 'SEND' : (shareDirection === 'receive' ? 'RETRIEVE' : null)"
                            [facilities]="vm.facilities"
                            [initialPatientId]="vm.currentFacilityPatientId?.value || vm.patient?.caseName"
                            [initialPatientName]="formattedPatientNameForSearch"
                            [isSpokeUser]="isSpokeUser"
                            [orthancUrl]="orthancUrl"
                            [patientCaseName]="vm.patient?.caseName"
                            [senderFacilityId]="vm.currentFacility"
                            [senderFacilityName]="currentFacilityName"
                            [targetFacilityId]="selectedTargetFacility?.facility"
                            [targetFacilityName]="targetFacilityName"
                            (studiesChanged)="onStudiesChanged($event)">
          </app-studies-page>
        </div>

        <div *ngIf="vm.shareTypeSelected === 'document' && shareDirection === 'send'"
             class="document-component-container"
             style="height: calc(100% - 45px); overflow: auto">
          <app-patient-share-documents [patientFromParent]="vm.patient"
                                       [patientID]="vm.patient?.caseName"></app-patient-share-documents>
        </div>

        <div *ngIf="vm.shareTypeSelected === 'document' && shareDirection === 'receive'"
             class="document-component-container"
             style="height: calc(100% - 45px); overflow: auto">
          <app-patient-retrieve-documents [patientFromParent]="vm.patient"
                                          [patientID]="vm.patient?.caseName"></app-patient-retrieve-documents>
        </div>

        <div *ngIf="activeImageShareTab !== 'studies'"
             class="image-share-iframe-container">
          <div *ngIf="vm.isIframeLoading"
               class="iframe-loading">
            Loading...
          </div>
          <div *ngIf="iframeError"
               class="iframe-error"
               style="padding: 20px; color: red">
            <strong>
              Error:
            </strong>
            {{ iframeError }}
          </div>
          <iframe *ngIf="vm.selectedImageShareUrl && !iframeError"
                  #orthancFrame
                  class="image-share-frame"

                  frameborder="0"
                  referrerpolicy="same-origin"

                  [src]="vm.selectedImageShareUrl | safe"
                  [title]="activeImageShareTitle"

                  (error)="onIframeError()"
                  (load)="onIframeLoaded()"></iframe>
        </div>
      </div>
    </div>
  </div>

  <!-- Option Selected Title -->
  <h3 *ngIf="optionSelected && !showDecisionScreen"
      class="option-selected-title"
      style="
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #f0f0f0;
    padding: 10px;
    border-radius: 5px;
    font-size: 1.2rem;
    font-weight: bold;
    border: 1px solid #ccc;
  ">
    {{ optionSelectedTitle }}
  </h3>

</div>
